var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"capsule-status pt-1"},[_c('b-badge',{staticClass:"pr-3 pl-3",attrs:{"pill":"","variant":_vm.getVariant(_vm.stateName)},domProps:{"innerHTML":_vm._s(_vm.stateName)}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-020ce94c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tailor/CapsuleStatus.vue
// module id = oWXf
// module chunks = 0